import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFetchPurchases } from '../../../../../../../../jsx/hooks/getPurchases';
import { isEmpty, size, sumBy, sum } from 'lodash';
import { getSpendingInfo } from '../../../../../../../../jsx/actions/paymentAction';

import { ListLayout } from '../../containers/Layout';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';
import { amber, red } from '@material-ui/core/colors';
import { toast } from 'react-toastify';
import Currency from '../../../../../commonModules/Currency';
import DeleteDialog from '../../../../../commonModules/interface/DeleteDialog';
import ConfirmValidation from '../../../../../commonModules/interface/ConfirmValidation';

import LinkPurchasePopUp from './LinkPurchasePopUp'; 
import {
	Checkbox,
	Box,
	Button,
	Typography,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	IconButton,
} from '@material-ui/core';
import {
	AddRounded,
	DeleteRounded,
	IndeterminateCheckBoxOutlined,
} from '@material-ui/icons';

const ListTransferPurchase = (props) => {
	const dispatch = useDispatch();
	const SHOPS = useSelector((state) => state.inventory.shops); 
	const STATE = useSelector((state) => state.inventory.requestState); 
	const PURCHASES = useSelector((state) => state.inventory.purchases.PURCHASES); 
	const fetchPurchasesData = useFetchPurchases();
	  const [showNew, setShowNew] = useState("");
	  const [breadcrumb, setBreadcrumb] = useState("");
	  const [spendingID, setSpendingID] = useState("");
	  const [deletePopUp, setDeletePopUp] = useState(false);
	  const [toDelete, setToDelete] = useState({
		id: ""
	  });
	  const [checkedPayments, setCheckedPayments] = useState([]);
	  const [parts, setParts] = useState({});
	  const [openLink, setOpenLink] = useState(false);
	  const [openUnLink, setOpenUnLink] = useState(false);
	  const [unlink, setUnlink] = useState({});
	  const [allChecked, setAllChecked] = useState(false);
	  const [totalPay, setTotalPay] = useState(0);

	  const [currentPage,setCurrentPage] = useState(0);
	  const [pageOfItems,setPageOfItems] = useState(20);

	  const [purchaseList, setPurchaseList] = useState([]);
	  const [purchaseListVeaw, setPurchaseListVeaw] = useState([]);
	  const [purchaseListInitial, setPurchaseListInitial] = useState([]);
  
	
	const [state, setState] = useState({
		single: {
			product_id: '',
			shop_id: '',
		},
		singleProd: {},
		singleShop: {},
		singlePurchase: {
			purchase: {},
			shop: {},
		},
		breadcrumb: '',
		deletePopUp: false,
		toDelete: {
			id: '',
		},
		checkedPayments: [],
		parts: {},
		openLink: false,
		openUnLink: false,
		unlink: {},
		sortDSC: false,

		confirmationState: false, // Open Dialog for confirmation of reception
        confirmationPurchaseID: {},// Purchase ID that need to be confirmed
	});

	useEffect(() => {
		console.log('MOUNTING ListTransferPurchases ',isEmpty(PURCHASES));
		if (isEmpty(PURCHASES)){
			fetchPurchasesData();
		}else{
			setPurchaseListInitial(PURCHASES)
		}
	}, []);

	useEffect(() => {
		console.log('UPDATING PURCHASES ');
		// this.filterList("")
		if (!isEmpty(PURCHASES)){
			setPurchaseListInitial(PURCHASES)
            setPurchaseList(PURCHASES)
		}
	}, [PURCHASES]);

	useEffect(() => {
		const purchaseList = displayList();
		setPurchaseListVeaw(purchaseList)
    }, [checkedPayments,purchaseListInitial,currentPage,pageOfItems]);
    useEffect(() => {
        if (currentPage === 0){
            const purchaseList = displayList();
			setPurchaseListVeaw(purchaseList)
        }else{
            setCurrentPage(0)
        }
    }, [props.start_date,props.end_date,props.selectShop,props.received,props.searchFacture,props.searchType ]);


	const handleClick = (event, payID) => {
		const selectedIndex = checkedPayments.indexOf(payID);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(checkedPayments, payID);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(checkedPayments.slice(1));
		} else if (selectedIndex === checkedPayments.length - 1) {
			newSelected = newSelected.concat(checkedPayments.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				checkedPayments.slice(0, selectedIndex),
				checkedPayments.slice(selectedIndex + 1),
			);
		}

		setCheckedPayments(newSelected);
		setTotalPay(calcTotal(newSelected));
	};

	const handleSelectAllClick = (event, list) => {
		console.log('🔍 handleSelectAllClick appelé avec:', { event, list, hasList: !!list, isArray: Array.isArray(list) });
		
		// Vérification de sécurité : s'assurer que list existe et est un tableau
		if (!list || !Array.isArray(list)) {
			console.error('❌ ERREUR: list est undefined ou n\'est pas un tableau dans handleSelectAllClick:', list);
			// Utiliser purchaseListInitial comme fallback si disponible
			if (purchaseListInitial && Array.isArray(purchaseListInitial)) {
				// Convertir l'objet en tableau si c'est un objet
				const listArray = Array.isArray(purchaseListInitial) 
					? purchaseListInitial 
					: Object.values(purchaseListInitial);
				list = props.getFilteredList ? props.getFilteredList(listArray) : listArray;
				console.log('✅ Utilisation de purchaseListInitial comme fallback:', list);
			} else {
				console.warn('⚠️ Aucun fallback disponible, utilisation d\'un tableau vide');
				list = [];
			}
		}

		const listAll = list.map((purchase) => purchase.id);

		if (event && event.target.checked) {
			let newList = listAll.slice(pageOfItems*(currentPage),pageOfItems*(currentPage+1))
			.filter(
				(ID) =>
				PURCHASES[ID] &&
				PURCHASES[ID].match_available &&
				PURCHASES[ID].nature !== "payg" &&
				!PURCHASES[ID].purchase_credit
			);

			setCheckedPayments(newList);
			setTotalPay(calcTotal(newList));
            setAllChecked(true);
		} else {
			setAllChecked(false);
			setCheckedPayments([]);
			setTotalPay(0);
			setSpendingID("");
			setOpenLink(false);
			setOpenUnLink(false);
		}
	};

	const createPurchaseList = (list) => {

		const isSelected = (name) => checkedPayments.indexOf(name) !== -1;
		const BCKG = (spending_id) => (!!spending_id ? amber[50] : 'initial');

		return list
		 .slice(pageOfItems*(currentPage),pageOfItems*(currentPage+1))
			.map((purchase, index) => {
			let shop = SHOPS[purchase.shop_id];
			return (
				<TableRow key={purchase.id} style={{ backgroundColor: BCKG(purchase.fact_id_5000) }}>
					<TableCell padding="checkbox">
						{purchase.match_available && (
							<Checkbox
								onClick={(event) => handleClick(event, purchase.id)}
								checked={isSelected(purchase.id)}
								inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
							/>
						)}
						{purchase.matched && (
						<Box p={1}>
							<IndeterminateCheckBoxOutlined
								onClick={() => {setUnlink(purchase); setOpenUnLink(true) } }
								style={{ color: red[100] }}
							/>
						</Box>
						)}
					</TableCell>
					<TableCell>{new Date(purchase.creation_date).toLocaleString('fr-FR')}</TableCell>
					<TableCell>
						<a href="#" onClick={() => props.handleSingleShop(shop)}>
						{' '}
						{shop && shop.name}
						</a>
					</TableCell>
					{purchase.received && <TableCell>Reçu</TableCell>}
					{!purchase.received && (
						<TableCell>
							<Button variant="contained" color="secondary" onClick={() => setState({ confirmationState: true, confirmationPurchaseID:purchase})}>
								Valider Reception
							</Button>
						</TableCell>
					)}
					<TableCell>{purchase.comments}</TableCell>
					<TableCell>
						<Currency value={purchase.prix_revient} />
					</TableCell>
					<TableCell>
						<IconButton color="secondary" onClick={() => props.handleSinglePurchase(purchase, shop)}>
							<AddRounded />
						</IconButton>
					</TableCell>

					<TableCell>
						{/* {!purchase.received && purchase.nature === 'achat' && (
						<IconButton
							color="secondary"
							onClick={() => props.handleUpdatePurchase(purchase)}
						>
							<EditRounded />
						</IconButton>
						)} */}
						{purchase.nature === 'achat' && (
						<IconButton
							onClick={() => {
								setToDelete(purchase);
								setDeletePopUp(true)
							}
								// setState({
								// 	toDelete: purchase,
								// 	deletePopUp: true,
								// })
							}
						>
							<DeleteRounded color="error" />
						</IconButton>
						)}
					</TableCell>
				</TableRow>
			);
		});
	};


	const displayList = () => {
		let tab = [];
		if (!isEmpty(PURCHASES)) {
			let filteredList = props.getFilteredList(purchaseListInitial);
			setPurchaseList(filteredList)

			tab = createPurchaseList(filteredList);
		}
		return tab;
	};

	const rmPayment = (payID) => {
		let cpParts = Object.assign({}, parts);
		let newList = [].concat(checkedPayments);
		newList = newList.filter((id) => id !== payID);
		delete cpParts[payID];

		setCheckedPayments(newList)
		setParts(cpParts)
		setTotalPay(calcTotalV2(newList))
		// setState({
		// 	...state,
		// 	checkedPayments: newList,
		// 	parts: cpParts,
		// 	totalPay: calcTotalV2(newList),
		// });
	};

	const handleChangeParts = (parts) => {
		setParts(parts)
		setTotalPay(sum(Object.values(parts)))
		// setState({
		// 	...state,
		// 	parts,
		// 	totalPay: sum(Object.values(parts)),
		// });
	};

	const handleGetSpendingInfo = async (id) => {
		return await dispatch(getSpendingInfo(id));
	};

	const handleSubmitLink = async () => {
		let data = {
			spending_id: spendingID,
			id_list: parts,
			total: calcTotalV2(checkedPayments),
		};
		await props.linkPurchasesTo5000(data);
		if (STATE.purchases.error) {
			console.log('ERROR', STATE.purchases.error);
			toast.error(STATE.purchases.error);
		} else {
			toast.info('Opération enregistrée avec succès');
			handleSelectAllClick();
		}
	};

	const handleSubmitUnLink = async () => {
		let data = {
			spending_id: unlink.fact_id_5000,
			id_list: [unlink.id],
			total: unlink.total_price,
		};
		await props.unLinkPurchasesTo5000(data);
		if (STATE.purchases.error) {
			console.log('ERROR', STATE.purchases.error);
			toast.error(STATE.purchases.error);
		} else {
			toast.info('Opération enregistrée avec succès');
			handleSelectAllClick();
		}
	};

	const calcTotal = (list) => {
		return sumBy(list, (purchaseID) => PURCHASES[purchaseID].total_available);
	};

	const calcTotalV2 = (list) => {
		return sumBy(list, (purchaseID) => parts[purchaseID]);
	};

	const deletePurchase = async (password) => {
		// Password is now passed from DeleteDialog and verified by backend
		try{
			// Add password to purchase object for backend verification
			const purchaseWithPassword = { 
				...toDelete,
				password: password 
			};
			const resp = await props.deletePurchase(purchaseWithPassword);
			toast.success('Achat supprimé avec succès');
			setDeletePopUp(false)
			setToDelete({ id: '' })
		}catch(err){
			console.log('[ERROR] delete purchase', err);
			const errorMsg = err?.message || String(err) || 'Erreur lors de la suppression';
			// If password error, show specific message
			if(errorMsg.includes('Mot de passe') || errorMsg.includes('password')){
				toast.error(errorMsg);
			} else {
				toast.error('Erreur: ' + errorMsg);
			}
		}

	};

	const changeStatus = async (purchase) => {
		console.log('[INFO] change status purchases.jsx');
		await props.receivePurchase(purchase);

		if (props.STATE.purchases.error) {
			console.log('ERROR', props.STATE.purchases.error);
			toast.error(props.STATE.purchases.error);
		} else {
			console.log('fetched');
			//success
			setState({ confirmationState: false})
			toast.info('Commande reçue');
		}
	};

	const onChangePage = (pageOfItemsTmp, page,rowsPerPage) =>{
        console.log("onChangePage >",pageOfItems,"-",page,"-",rowsPerPage,"-",currentPage)
        if (!(typeof rowsPerPage === "undefined")){
            setPageOfItems(Number(rowsPerPage))  
        }
        setCurrentPage(Number(page))
    }

	return (
		<Box>
			{deletePopUp && (
				<DeleteDialog
					title={'l\'achat n°' + toDelete.id}
					handleSubmit={deletePurchase}
					block={true}
					close={() => setDeletePopUp(false) }
					// close={() => setState({ ...state, deletePopUp: false })}
				/>
			)}
			{size(checkedPayments) > 0 && (
				<Button variant="contained" color="primary" onClick={() => setOpenLink(true)}>
					Pointer {size(checkedPayments)} achats
				</Button>
			)}
			{openLink && size(checkedPayments) > 0 && (
				<LinkPurchasePopUp
					handleClose={() => { setOpenLink(false); setSpendingID('') }}
					rmPayment={rmPayment}
					handleSubmitLink={handleSubmitLink}
					handleChangeParts={handleChangeParts}
					handleChange={(e) => {
						if (e.target.name === 'spendingID') {
							setSpendingID(e.target.value);
						}
					}}
					getSpendingInfo={handleGetSpendingInfo}
					checkedPayments={checkedPayments}
					totalPay={totalPay}
					spendingID={spendingID}
					PURCHASES={PURCHASES}
					SHOPS={SHOPS}
				/>
			)}
			{openUnLink && !isEmpty(unlink) && (
				<DeleteDialog open={true} title="le pointage" close={() => {setOpenUnLink(false); setUnlink({}) }} handleSubmit={handleSubmitUnLink} />
			)}

			{state.confirmationState && <ConfirmValidation 
                        open={state.confirmationState}
                        title="le pointage"
                        handleClose={()=> setState({ confirmationState: false})}
                        handleConfirm={()=> changeStatus(state.confirmationPurchaseID)}
                />
			}
			<Box p={1}>
				<Typography variant="h6">Liste des achats</Typography>
			</Box>
			<ListLayout>
				<TableHead>
					<TableRow>
						<TableCell padding="checkbox">
							<Checkbox
								indeterminate={size(checkedPayments) > 0 && size(checkedPayments) < (Array.isArray(purchaseList) ? purchaseList.length : 0)}
								checked={allChecked}
								onChange={(e) => handleSelectAllClick(e, purchaseList)}
								inputProps={{ 'aria-label': 'Selectionner tout' }}
							/>
						</TableCell>
						<TableCell>Date</TableCell>
						<TableCell>Shop</TableCell>
						<TableCell>Statut</TableCell>
						<TableCell>Remarques</TableCell>
						<TableCell>Coût Total</TableCell>
						<TableCell>Détails</TableCell>
						<TableCell>Options</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{purchaseList.length > 0 && purchaseListVeaw}
					{purchaseList.length === 0 && (
					<TableRow>
						<TableCell colSpan={7}>
							<div className="text-center">
								Cliquez sur{' '}
								<Button
									color="primary"
									className="text-right"
									onClick={() => {
										setShowNew(true); 
										setBreadcrumb('Nouveau');
										// setState({ ...state, showNew: true, breadcrumb: 'Nouveau' });
									}}
								>
									Nouveau
								</Button>{' '}
								pour entrer un nouvel Achat
							</div>
						</TableCell>
					</TableRow>
					)}
				</TableBody>
				{purchaseList.length > 20 && (
					<TableFooterPagination
						colSpan={8}
						count={purchaseList.length}
						onChangePage={onChangePage}
						initialPage={0}
						page={currentPage}
					/>
				)}
			</ListLayout>
		</Box>
	);
};

export default ListTransferPurchase;
